import React from "react";

const Vip = () => {
  return (
    <div data-v-c129d1f8 id="br_proxy_right" className="br_acmc_mright">
      {/*?xml version="1.0" encoding="UTF-8"?*/}
      <div id="mc_container" className="playerRank EN">
        <div id="switchTab" className="tab-nav">
          <span
            className="nav-item active"
            data-target="benefits"
            translate="level_interests"
          >
            Rank Benefits
          </span>
          <span
            className="nav-item"
            data-target="memberRules"
            translate="label_rule"
          >
            Rules
          </span>
          <span
            className="nav-item"
            data-target="benefitsRecords"
            translate="benefits_records"
          >
            Rewards History
          </span>
        </div>
        <div id="playerRank_wrap" style={{ overflow: "hidden" }}>
          {/*?xml version="1.0" encoding="UTF-8"?*/}
          <div
            className="benefits"
            style={{ "background-color": "rgb(255, 255, 255)" }}
          >
            <div className="benefits-info">
              <div className="member-info">
                <div className="level-head">
                  <span className="icon" />
                  <div
                    className="member-avatar"
                    style={{
                      "background-image":
                        'url("https://images.0756931.com/TCG_PROD_IMAGES/B2C/01_PROFILE/PROFILE/0.png")',
                    }}
                  ></div>
                  <span className="level-name">VIP0</span>
                </div>
                <div className="member-name">
                  <div className="name">joybajee</div>
                </div>
                <div className="member-balance">
                  <span className="balance">
                    <span className="symbol front">৳</span> <span>0.00</span>
                  </span>
                </div>
              </div>
              <div className="levelMaintain-card inactive hide">
                <div>
                  <div className="desc" />
                </div>
              </div>
            </div>
            <div className="benefits-condition">
              <div className="next-level-rule flex-width-full">
                <div className="title" translate="up_conditions">
                  Level Up Requirements
                </div>
                <span className="title-tips" translate="up_conditions_tips">
                  Fulfill any conditions to upgrade
                </span>
                <div className="rule-wrapper">
                  <div
                    className="level-swiper-button-prev swiper-button-disabled"
                    tabIndex={-1}
                    role="button"
                    aria-label="Previous slide"
                    aria-controls="swiper-wrapper-135bc4dcaad21e85"
                    aria-disabled="true"
                    style={{ display: "none" }}
                  />
                  <div
                    className="level-swiper-button-next"
                    tabIndex={0}
                    role="button"
                    aria-label="Next slide"
                    aria-controls="swiper-wrapper-135bc4dcaad21e85"
                    aria-disabled="false"
                    style={{ display: "none" }}
                  />
                  <div className="rule-container">
                    <div className="levelup-swiper swiper-initialized swiper-horizontal">
                      <div className="swiper-title-wrap">
                        <div className="levelup-item" data-name="totalDeposit">
                          Total deposit
                        </div>
                        <div className="levelup-item" data-name="totalTurnover">
                          Total bet
                        </div>
                      </div>
                      <div
                        className="swiper-wrapper"
                        style={{
                          "-webkit-transition-duration": "0ms",
                          "transition-duration": "0ms",
                          "-webkit-transform": "translate3d(284.8px, 0px, 0px)",
                          "-ms-transform": "translate3d(284.8px, 0px, 0px)",
                          transform: "translate3d(284.8px, 0px, 0px)",
                        }}
                        id="swiper-wrapper-135bc4dcaad21e85"
                        aria-live="polite"
                      >
                        <div
                          className="swiper-slide swiper-slide-active"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="1 / 35"
                        >
                          <div
                            className="rule-item lv9"
                            startcolor="endColor="
                            currentlevel="lv9"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP0
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">100.00</span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">2,000.00</span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-next"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="2 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP1
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">100.00</span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">20,000.00</span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="3 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP2
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">100.00</span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  100,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="4 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP3
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">100.00</span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  300,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="5 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP4
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">100.00</span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  700,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="6 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP5
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">100.00</span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  1,200,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="7 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP6
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">100.00</span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  2,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="8 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP7
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">100.00</span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  5,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="9 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP8
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">100.00</span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  8,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="10 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP9
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">100.00</span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  12,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="11 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP10
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  20,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="12 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP11
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  40,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="13 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP12
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  70,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="14 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP13
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  100,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="15 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP14
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  130,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="16 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP15
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  160,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="17 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP16
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  200,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="18 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP17
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  250,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="19 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP18
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  300,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="20 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP19
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  340,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="21 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP20
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  380,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="22 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP21
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  420,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="23 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP22
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  480,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="24 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP23
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  540,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="25 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP24
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  620,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="26 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP25
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  700,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="27 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP26
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  800,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="28 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP27
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  900,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="29 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP28
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  1,000,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="30 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP29
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  1,200,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="31 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP30
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  1,500,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="32 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP31
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  2,000,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="33 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP32
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  2,500,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="34 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP33
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  3,000,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          style={{ width: "142.4px" }}
                          role="group"
                          aria-label="35 / 35"
                        >
                          <div
                            className="rule-item lv18"
                            startcolor="rgba(255,236,170,1)"
                            endcolor="rgba(230,177,75,1)"
                            currentlevel="lv18"
                          >
                            <div className="rule-title">
                              <span className="vipicon" />
                              VIP34
                            </div>
                            <div className="item-info">
                              <div className="item-top hide">
                                <span className="level-name">0</span>/
                                <span className="item-expected">0</span>
                              </div>
                              <div className="item-bottom">-</div>
                            </div>
                            <div className="item-info">
                              <div className="item-top ">
                                <span className="level-name">0</span>/
                                <span className="item-expected">
                                  4,000,000,000.00
                                </span>
                              </div>
                              <div className="item-bottom">0%</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span
                        className="swiper-notification"
                        aria-live="assertive"
                        aria-atomic="true"
                      />
                    </div>
                  </div>
                  <div
                    className="swiper-pagination-level swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal swiper-pagination-bullets-dynamic"
                    style={{ width: "130px" }}
                  >
                    <span
                      className="swiper-pagination-bullet swiper-pagination-bullet-active swiper-pagination-bullet-active-main"
                      style={{ left: "52px" }}
                      tabIndex={0}
                      aria-current="true"
                    >
                      1
                    </span>
                    <span
                      className="swiper-pagination-bullet swiper-pagination-bullet-active-next"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      2
                    </span>
                    <span
                      className="swiper-pagination-bullet swiper-pagination-bullet-active-next-next"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      3
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      4
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      5
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      6
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      7
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      8
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      9
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      10
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      11
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      12
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      13
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      14
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      15
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      16
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      17
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      18
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      19
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      20
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      21
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      22
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      23
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      24
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      25
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      26
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      27
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      28
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      29
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      30
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      31
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      32
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      33
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      34
                    </span>
                    <span
                      className="swiper-pagination-bullet"
                      style={{ left: "52px" }}
                      tabIndex={0}
                    >
                      35
                    </span>
                  </div>
                </div>
              </div>
              <div
                className="next-level-rule rewards-List-wrap hide flex-width-full"
                style={{ display: "none" }}
              >
                <div className="title" translate="rewards_level_ltitle">
                  Salary
                </div>
                <div className="rewards-level-container">
                  <div className="search-date-range">
                    <span
                      className="rewards-date hide active"
                      data-name="dailyconfig"
                      translate="one_day"
                    >
                      1 day
                    </span>
                    <span
                      className="rewards-date hide"
                      data-name="weeklyconfig"
                      translate="seven_days"
                    >
                      7 days
                    </span>
                    <span
                      className="rewards-date hide"
                      data-name="monthlyconfig"
                      translate="thirty_days"
                    >
                      30 days
                    </span>
                  </div>
                  <div className="rewards-ticket-list" />
                </div>
              </div>
            </div>
            <div className="condition hide">
              <div className="title" translate="level_interests">
                VIP0 - Rank Benefits
              </div>
              <div className="condition-container">
                <div className="benefits-swiper">
                  <div className="swiper-wrapper" />
                </div>
              </div>
            </div>
            <div className="model-case all-h" id="js_announce_content" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vip;
